module.exports = __webpack_public_path__ + "static/media/distribution_modes.d0ab462a.jpg";